module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tw-h-full noselect"
  }, [_c('div', {
    staticClass: "tw-text-sm tw-italic"
  }, [_vm._v("Les champs marqués d'un * sont obligatoires")]), _vm._v(" "), _c('Form', {
    key: _vm.cleFormulaireEntree,
    ref: "formEntreeSalarie",
    staticClass: "tw-h-[calc(100%-20px)]",
    attrs: {
      "readonly": _vm.readOnly,
      "dataForm": _vm.dataForm
    },
    on: {
      "update:dataForm": function($event) {
        _vm.dataForm = $event
      }
    }
  }, [_c('div', {
    staticClass: "tw-h-full"
  }, [(!_vm.dataReady) ? _c('div', {
    staticClass: "tw-absolute tw-top-0 tw-bottom-0 tw-left-0 tw-right-0 tw-bg-gray-500/10 tw-z-10"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), _c('VerticalScroll', {
    ref: "scrollFormEntreeSalarie",
    staticClass: "tw-h-full",
    attrs: {
      "padding": true
    }
  }, [_c('div', {
    staticClass: "tw-flex tw-h-full entree-salarie-container"
  }, [_c('div', {
    staticClass: "tw-w-1/2 tw-h-full tw-mr-2"
  }, [_c('div', {
    staticClass: "tw-mb-3"
  }, [_c('div', {
    staticClass: "tw-flex tw-items-center tw-justify-between tw-mb-0.5"
  }, [_c('Title', [_vm._v("Salarié")]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex"
  }, [_c('Checkbox', {
    staticClass: "tw-mr-3",
    attrs: {
      "toNumber": true,
      "disabled": _vm.readOnly,
      "vmodel": _vm.entreeSalarie.ContratTravail,
      "label": "Modèle de contrat de travail",
      "title": "Modèle de contrat de travail"
    },
    on: {
      "changed": _vm.changed,
      "update:vmodel": function($event) {
        _vm.$set(_vm.entreeSalarie, "ContratTravail", $event)
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "Les déclarations d'embauches (CRPCEN, URSSAF)",
      "toNumber": true,
      "disabled": _vm.readOnly,
      "vmodel": _vm.entreeSalarie.DeclarationsEmbauches,
      "title": "Les déclarations d'embauches (CRPCEN, URSSAF)"
    },
    on: {
      "changed": _vm.changed,
      "update:vmodel": function($event) {
        _vm.$set(_vm.entreeSalarie, "DeclarationsEmbauches", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-border tw-rounded tw-p-5 "
  }, [_c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-2/12 tw-mr-3",
    attrs: {
      "data-testid": "entryRequest-civilite-field"
    }
  }, [_c('CiviliteSelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.civilite
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "civilite", $event)
      },
      "changed": function($event) {
        _vm.changed('secu'), _vm.changed('rib')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-5/12 tw-mr-3"
  }, [_c('InputTextForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.nom,
      "data-testid": "entryRequest-nom-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "nom", $event)
      },
      "changed": function($event) {
        _vm.changed('rib')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-5/12"
  }, [_c('InputTextForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.prenom,
      "data-testid": "entryRequest-prenom-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "prenom", $event)
      },
      "changed": function($event) {
        _vm.changed('rib')
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('InputTextForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.nomNaissance,
      "data-testid": "entryRequest-nomNaissance-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "nomNaissance", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('InputDateForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.dateNaissance,
      "data-testid": "entryRequest-dateNaissance-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "dateNaissance", $event)
      },
      "changed": function($event) {
        _vm.changed('secu')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12"
  }, [_c('AutoCompleteForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.communeNaissance,
      "data-testid": "entryRequest-lieuNaissance-field",
      "listOption": _vm.transformListCommuneFull(_vm.listeCommune),
      "valueIsKey": true,
      "isSaisieLibre": true
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "communeNaissance", $event)
      },
      "changed": function($event) {
        _vm.changed('secu')
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('AutoCompleteForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.pays,
      "data-testid": "entryRequest-paysNaissance-field",
      "listOption": _vm.transformList(_vm.listePays)
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "pays", $event)
      },
      "changed": function($event) {
        _vm.changed('secu')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('AutoCompleteForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.nationalite,
      "data-testid": "entryRequest-nationalite-field",
      "listOption": _vm.transformList(_vm.listePays)
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "nationalite", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12"
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.situation,
      "data-testid": "entryRequest-situationFamiliale-field",
      "listOption": _vm.listeSituation
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "situation", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-6/12 tw-mr-3"
  }, [_c('InputTextForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.adresse,
      "data-testid": "entryRequest-adresse-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "adresse", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-6/12"
  }, [_c('InputTextForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.complement,
      "data-testid": "entryRequest-complementAdresse-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "complement", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('AutoCompleteForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.codepostal,
      "data-testid": "entryRequest-codePostal-field",
      "dataInputOptionLink": _vm.dataForm.commune,
      "isLink": true,
      "isCP": true,
      "isSaisieLibre": true,
      "listOptionRaw": _vm.listeCommune
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "codepostal", $event)
      },
      "update:dataInputOptionLink": function($event) {
        _vm.$set(_vm.dataForm, "commune", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-8/12"
  }, [_c('AutoCompleteForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.commune,
      "data-testid": "entryRequest-ville-field",
      "dataInputOptionLink": _vm.dataForm.codepostal,
      "isLink": true,
      "isSaisieLibre": true,
      "listOptionRaw": _vm.listeCommune
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "commune", $event)
      },
      "update:dataInputOptionLink": function($event) {
        _vm.$set(_vm.dataForm, "codepostal", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex"
  }, [_c('div', {
    staticClass: "tw-w-8/12 tw-mr-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataForm.secu.vmodel),
      expression: "dataForm.secu.vmodel"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "disabled": _vm.dataForm.secu.disabled,
      "maxlength": "21",
      "data-testid": "entryRequest-numSS-field",
      "required": ""
    },
    domProps: {
      "value": (_vm.dataForm.secu.vmodel)
    },
    on: {
      "blur": function($event) {
        _vm.onBlurNumeroSecuriteSocial()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataForm.secu, "vmodel", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("N° sécurité sociale")])])]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12"
  }, [_c('InputNumberForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.crpcen,
      "data-testid": "entryRequest-numCRPCEN-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "crpcen", $event)
      },
      "changed": _vm.changed
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tw-mb-3"
  }, [_c('div', {
    staticClass: "tw-flex tw-items-center tw-mb-0.5"
  }, [_c('Title', [_vm._v("Coordonnées")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-border tw-rounded tw-p-5 "
  }, [_c('div', {
    staticClass: "tw-flex"
  }, [_c('div', {
    staticClass: "tw-w-3/12 tw-mr-3"
  }, [_c('InputTelephoneForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.telephoneFixe,
      "data-testid": "entryRequest-fixe-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "telephoneFixe", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-3/12 tw-mr-3"
  }, [_c('InputTelephoneForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.telephonePortable,
      "data-testid": "entryRequest-mobile-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "telephonePortable", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-3/12 tw-mr-3"
  }, [_c('InputEmailForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.emailPerso,
      "data-testid": "entryRequest-email-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "emailPerso", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-3/12"
  }, [_c('InputEmailForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.emailPro,
      "data-testid": "entryRequest-proEmail-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "emailPro", $event)
      },
      "changed": _vm.changed
    }
  })], 1)])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "tw-flex tw-items-center tw-mb-0.5"
  }, [_c('Title', [_vm._v("Éléments variables")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-border tw-rounded tw-p-5 "
  }, [_c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-4/12 tw-pr-2"
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.mutuelle,
      "data-testid": "entryRequest-mutuelle-field",
      "listOption": _vm.transformList(_vm.listeMutuelles),
      "maxHeight": 408
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "mutuelle", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex"
  }, [_c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.transport,
      "data-testid": "entryRequest-remboursementsTransport-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "transport", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('InputDecimalForm', {
    attrs: {
      "data-testid": "entryRequest-restaurantVouchers-field",
      "dataInputOption": _vm.dataForm.titreRestaurant
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "titreRestaurant", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12"
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.modeReglement,
      "data-testid": "entryRequest-modeReglement-field",
      "listOption": _vm.listeReglement,
      "id": "modeReglementForm"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "modeReglement", $event)
      },
      "changed": function($event) {
        _vm.changed('rib')
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-1/2 tw-h-full tw-ml-2 "
  }, [_c('div', {
    staticClass: "tw-mb-3"
  }, [_c('div', {
    staticClass: "tw-flex tw-items-center tw-mb-0.5"
  }, [_c('Title', [_vm._v("Contrat de travail")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-border tw-rounded tw-p-5"
  }, [_c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-6/12 tw-mr-3"
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.classification,
      "data-testid": "entryRequest-classification-field",
      "listOption": _vm.transformList(_vm.listeClassifications),
      "maxHeight": 400
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "classification", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-6/12"
  }, [_c('InputTextForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.intitule,
      "data-testid": "entryRequest-intitulePoste-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "intitule", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-6/12 tw-mr-3"
  }, [_c('InputDateForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.dateEntree,
      "data-testid": "entryRequest-dateEntree-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "dateEntree", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-6/12"
  }, [_c('InputDateForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.dateEntreeMetier,
      "data-testid": "entryRequest-dateEntreeMetier-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "dateEntreeMetier", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-6/12 tw-mr-3",
    class: {
      'heures-semaine-error': _vm.hasHorairesError
    }
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.heuresSemaine,
      "data-testid": "entryRequest-heuresSemaine-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "heuresSemaine", $event)
      },
      "changed": function($event) {
        _vm.changed('heuresSemaine')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-6/12 tw-mr-3"
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.heuresSupSemaine,
      "data-testid": "entryRequest-heuresSupSemaine-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "heuresSupSemaine", $event)
      },
      "changed": function($event) {
        _vm.changed('heuresSupSemaine')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-6/12"
  }, [_c('div', {
    staticClass: "horaires-presence-field"
  }, [_c('div', {
    staticClass: "inp-input icon horaires-presence-inp",
    class: {
      warning: _vm.showHorairesPresenceAlerte || _vm.hasHorairesError,
        'horaires-presence-inp--vide': !_vm.horairesPresenceRenseignes && !_vm.hasHorairesError,
        'is-disabled': _vm.readOnly || !_vm.dataReady
    },
    attrs: {
      "data-testid": "horaires-presence-field"
    },
    on: {
      "click": function($event) {
        !_vm.readOnly && _vm.dataReady && _vm.openHoraireHebdo()
      }
    }
  }, [_c('input', {
    key: _vm.horairesPresenceLibelle,
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": "",
      "disabled": _vm.readOnly || !_vm.dataReady,
      "placeholder": " ",
      "title": _vm.isTempsPartiel ? 'Les horaires de présence sont obligatoires pour ce contrat' : 'Horaires de présence'
    },
    domProps: {
      "value": _vm.horairesPresenceLibelle
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Horaires de présence")]), _vm._v(" "), (_vm.showHorairesPresenceAlerte || _vm.hasHorairesError) ? _c('span', {
    staticClass: "icon-alerte ri-alert-line"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "icon-inner ri-pencil-line"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-6/12 tw-mr-3"
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.heuresMois,
      "data-testid": "entryRequest-heuresMois-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "heuresMois", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-6/12"
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.heuresSupMois,
      "data-testid": "entryRequest-heuresSupMois-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "heuresSupMois", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-8/12 tw-mr-3",
    class: {
      'tw-hidden': Number(_vm.dataForm.heuresSupSemaine.vmodel) == 0
    }
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.typeMajoration,
      "listOption": _vm.transformList(_vm.listeTypesMajoration)
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "typeMajoration", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.salaire,
      "data-testid": "entryRequest-dalireBrut-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "salaire", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.nombrePoint,
      "data-testid": "entryRequest-nbPointsComplementaires-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "nombrePoint", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12"
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.complementSalaire,
      "data-testid": "entryRequest-complementSalaire-field"
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "complementSalaire", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex"
  }, [_c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.nature,
      "data-testid": "entryRequest-natureContrat-field",
      "listOption": _vm.transformList(_vm.listeNatures)
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "nature", $event)
      },
      "changed": function($event) {
        _vm.changed('nature')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.type,
      "data-testid": "entryRequest-typeContrat-field",
      "listOption": _vm.transformList(_vm.listeTypeContrats)
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "type", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12 entree-salarie-regime-select",
    on: {
      "!pointerdown": function($event) {
        return _vm.onRegimeSelectPointerCapture($event)
      }
    }
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.regime,
      "data-testid": "entryRequest-regimeSanteRetraite-field",
      "listOption": _vm.listeOptionsRegimeAvecAide
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "regime", $event)
      },
      "changed": _vm.onRegimeFieldChanged
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-mt-2",
    class: {
      'tw-hidden': _vm.dataForm.nature.vmodel !== 'CDD'
    }
  }, [_c('div', {
    staticClass: "tw-w-6/12 tw-mr-3"
  }, [_c('InputDateForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.dateFinCdd
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "dateFinCdd", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-6/12"
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.motifRecours,
      "listOption": _vm.transformListMotifRecours
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "motifRecours", $event)
      },
      "changed": function($event) {
        _vm.changed('remplace')
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-mt-2",
    class: {
      'tw-hidden': _vm.dataForm.nature.vmodel !== 'CDD' || _vm.dataForm.motifRecours.vmodel !== 'REMP'
    }
  }, [_c('div', {
    staticClass: "tw-w-full"
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.salarieRemplace,
      "listOption": _vm.transformListSalarie(_vm.listeSalariesActifs)
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "salarieRemplace", $event)
      },
      "changed": _vm.changed
    }
  })], 1)])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "tw-flex tw-items-center tw-justify-between tw-mb-0.5"
  }, [_c('Title', [_vm._v("Autres informations")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-border tw-rounded tw-p-5 "
  }, [_c('div', {
    staticClass: "tw-flex"
  }, [_c('div', {
    staticClass: "tw-w-full"
  }, [_c('TextareaForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.divers
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "divers", $event)
      },
      "changed": _vm.changed
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tw-mt-3",
    class: {
      'tw-hidden': _vm.dataForm.modeReglement.vmodel !== '3'
    }
  }, [_c('div', {
    staticClass: "tw-flex tw-items-center tw-justify-between tw-mb-0.5"
  }, [_c('Title', [_vm._v("Relevé d'identité bancaire")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-border tw-rounded tw-p-5 "
  }, [_c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-1/12 tw-mr-3"
  }, [_c('div', {
    staticClass: "tw-font-bold tw-h-[43px] tw-flex tw-items-center"
  }, [_vm._v("IBAN")])]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-2/12 tw-mr-3"
  }, [_c('InputTextForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.cp
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "cp", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-2/12 tw-mr-3"
  }, [_c('InputNumberForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.cc
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "cc", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-7/12"
  }, [_c('InputTextForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.bban
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "bban", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-1/12 tw-mr-3"
  }, [_c('div', {
    staticClass: "tw-font-bold tw-h-[43px] tw-flex tw-items-center"
  }, [_vm._v("BIC")])]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-11/12"
  }, [_c('InputTextForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.bic
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "bic", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex"
  }, [_c('div', {
    staticClass: "tw-w-1/12 tw-mr-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "tw-w-6/12 tw-mr-3"
  }, [_c('InputTextForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.domiciliation
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "domiciliation", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-5/12"
  }, [_c('InputTextForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.nomBanque
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "nomBanque", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex"
  }, [_c('div', {
    staticClass: "tw-w-1/12 tw-mr-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "tw-w-11/12 tw-mr-3"
  }, [_c('InputTextForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.titulaire
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "titulaire", $event)
      },
      "changed": _vm.changed
    }
  })], 1)])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "boutons-actions",
    staticStyle: {
      "padding-right": "20px"
    }
  }, [_c('div', {
    staticClass: "tw-inline-flex tw-border tw-p-5 tw-rounded tw-shadow tw-bg-white"
  }, [_c('Button', {
    class: {
      'tw-mr-3': !_vm.readOnly
    },
    attrs: {
      "icon": "fa-solid fa-circle-xmark",
      "color": "red",
      "disabled": !_vm.dataReady,
      "outline": true,
      "title": !_vm.readOnly ? 'Annuler les modifications' : 'Fermer',
      "text": !_vm.readOnly ? 'Annuler les modifications' : 'Fermer'
    },
    on: {
      "click": function($event) {
        _vm.cancelButton()
      }
    }
  }), _vm._v(" "), (!_vm.readOnly) ? _c('Button', {
    staticClass: "tw-mr-3",
    attrs: {
      "data-testid": "entryRequest-save-button",
      "icon": "fa-solid fa-floppy-disk",
      "color": "blue",
      "disabled": !_vm.isModified || !_vm.dataReady,
      "title": _vm.entreeSalarie.Id === 0 ? 'Enregistrer la saisie' : 'Modifier la saisie',
      "text": _vm.entreeSalarie.Id === 0 ? 'Enregistrer la saisie' : 'Modifier la saisie'
    },
    on: {
      "click": function($event) {
        _vm.saveButton()
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.readOnly && _vm.canValider()) ? _c('Button', {
    attrs: {
      "data-testid": "entryRequest-validate-button",
      "icon": "fa-solid fa-paper-plane-top",
      "color": "green",
      "disabled": !_vm.dataReady,
      "title": 'Valider l\'entrée',
      "text": 'Valider l\'entrée'
    },
    on: {
      "click": function($event) {
        _vm.validate()
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.readOnly && _vm.canSoumettre()) ? _c('Button', {
    attrs: {
      "data-testid": "entryRequest-send-button",
      "icon": "fa-solid fa-paper-plane-top",
      "color": "green",
      "disabled": !_vm.dataReady,
      "title": 'Transmettre',
      "text": 'Transmettre'
    },
    on: {
      "click": function($event) {
        _vm.submitButton()
      }
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), (_vm.showModalHoraireHebdo) ? _c('modal-horaire-hebdo', {
    attrs: {
      "horaire-hebdo-initial": _vm.horaireHebdoPourModale,
      "heuresParSemaine": _vm.libelleHeuresPourModale
    },
    on: {
      "horaireHebdoUpdated": _vm.onHoraireHebdoUpdated,
      "closeModal": function($event) {
        _vm.showModalHoraireHebdo = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('modal-transfert-absences-futures', {
    ref: "modalTransfertAbsencesFutures",
    attrs: {
      "data-backdrop": "static"
    }
  }), _vm._v(" "), (_vm.modalRegimeDecisionVisible) ? _c('modal-regime-decision-entree-salarie', {
    attrs: {
      "liste-maladie-retraites": _vm.listeMaladieRetraitesFiltered
    },
    on: {
      "apply": _vm.onRegimeDecisionApply,
      "closed": function($event) {
        _vm.modalRegimeDecisionVisible = false
      }
    },
    model: {
      value: (_vm.isManualChoice),
      callback: function($$v) {
        _vm.isManualChoice = $$v
      },
      expression: "isManualChoice"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7952254e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/entreeSalarie/entreeSalarie.vue.html
// module id = 0QFJ
// module chunks = 2